import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

const NoData = ({ runTest, isRunningTest }) => {
  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 text-yellow-700">
      <div className="flex items-center mb-2">
        <AlertCircle size={20} className="mr-2" />
        <span className="font-bold">No Data Available</span>
      </div>
      <p className="mb-4">No details are available for this test. Please run the security tests to generate data.</p>
      <button
        onClick={runTest}
        disabled={isRunningTest}
        className="flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors disabled:bg-blue-400"
      >
        <RefreshCw size={16} className={`mr-2 ${isRunningTest ? 'animate-spin' : ''}`} />
        {isRunningTest ? 'Running Test...' : 'Run Test Now'}
      </button>
    </div>
  );
};

export default NoData;
